import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import shiftTemplates from 'modules/shift_management/store/api/collections/shiftTemplates'

interface Props {
  onClose: () => void
}

const AddShiftTemplate = ({ onClose }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const [running, setRunning] = React.useState(false)

  const form = useLazyRef<Form>(
    () =>
      new Form(
        {},
        {
          name: 'string',
        }
      )
  ).current

  const onSubmit = async () => {
    setRunning(true)

    const result = await asyncAction(() => {
      return shiftTemplates.create(form.data())
    })
    setRunning(false)

    if (isSuccessful(result)) {
      navigate(
        navigation.shifts.templates.templatesShiftTemplateId.fullPath({
          shiftTemplateId: result.value.id,
        })
      )
    }
  }

  return (
    <Modal
      illustration="document-edit"
      title={i18n.t('shift_management.rotating_shifts.modal_title')}
      description={i18n.t('shift_management.rotating_shifts.modal_description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running || !form.isDirty} type="primary" submit>
            {i18n.t('common.next')}
          </Button>
        </>
      }
    >
      <Text
        label={i18n.t('shift_management.rotating_shifts.modal_label_shift_name')}
        placeholder={i18n.t('shift_management.rotating_shifts.modal_placeholder')}
        field={form.get('name')}
      />
    </Modal>
  )
}

export default observer(AddShiftTemplate)
